import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import Comments from "../COMPONENTS/CommentsModalWindow";
import {openCommentModal} from "./../../REDUX/functions.js";

function mapStateToProps(state) {
    return {
        OPEN_COMMENTS: state.OPEN_COMMENTS,
        USER: state.USER
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class CommentsModal extends Component {

    /// CONSTRUCTOR ///
    constructor(props)
    {
        super(props);
    }



    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.OPEN_COMMENTS !== prevProps.OPEN_COMMENTS) {
            if (window.innerWidth < 1200) {
                if (!this.props.OPEN_COMMENTS) {
                    document.body.classList.remove("modal-open");
                    document.documentElement.scrollTop = this.OFFSET;
                } else {
                    this.OFFSET = window.pageYOffset || document.documentElement.scrollTop;
                    document.body.classList.add("modal-open");
                }
            }
        }
    }

    renderContent = () =>
    {
        if (this.props.OPEN_COMMENTS) {
            return <Comments PRODUCT={this.props.OPEN_COMMENTS.product} DATE_TILL={this.props.OPEN_COMMENTS.date_till} DATE_FROM={this.props.OPEN_COMMENTS.date_from}/>
        }
    }

    render()
    {
        if (this.props.OPEN_COMMENTS) {
            return (
                <div className="modal">
                    <div className="modal-overlay" onClick={() => this.props.openCommentModal(false)}>
                    </div>
                    <div className="modal-box">
                        {this.renderContent()}
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(CommentsModal);